module.exports = __webpack_public_path__ + "assets/img/9september_dark.5054c127.jpeg";